import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {SchoolTypesState, RAW_DATA_UPDATE_EVENT} from '../../schoolTypes/state';
import {FilterState, CHANGE_EVENT} from '../state';
import { alphabetArray } from '../../config';
import { MunicipalitiesState, TEXT_ALL_MUNICIP } from '../../municipalities/state';
import { connect } from 'react-redux';
import InputLabel from '@material-ui/core/InputLabel';

const names = [
/*  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',*/
];



class Autonomy extends React.Component{
	constructor(props) {
		super(props);

		this.state = {
			values: FilterState.getMunicipalities(),
			municipalities: this.getMunicipalities()
		}

		this.setMuncipalitiesHandler = this.setMuncipalitiesHandler.bind(this);
		this.setFilterValueHandler = this.setFilterValueHandler.bind(this);
	}

	componentDidMount(){

		SchoolTypesState.on(RAW_DATA_UPDATE_EVENT, this.setMuncipalitiesHandler);
		FilterState.on(CHANGE_EVENT, this.setFilterValueHandler);
	}

	setMuncipalitiesHandler() {

		this.setState({municipalities: this.getMunicipalities()});
	}

	setFilterValueHandler() {

		this.setState({values: FilterState.getMunicipalities()});
	}


	componentWillUnmount() {

		SchoolTypesState.removeListener(RAW_DATA_UPDATE_EVENT, this.setMuncipalitiesHandler)
		FilterState.removeListener(CHANGE_EVENT, this.setFilterValueHandler)
	}

	getMunicipalities() {

		return MunicipalitiesState.get();
	}

	handleChange(event, index){
		
		var values = event.target.value;

		if(values !== TEXT_ALL_MUNICIP && this.state.values.indexOf(values) == -1) {

			FilterState.setMunicipality([values]);
		} else {
			FilterState.clearMunicipalities();
		}
		

		return;
	}

  	menuItems(values, municipalities) {
	    return municipalities.map((name) => (
	      <MenuItem
	        key={name}
	        insetChildren={true}
	        checked={values && values.includes(name)}
	        value={name}
	        style={{fontSize: '12px'}}
	        primaryText={name}
	      >{name}</MenuItem>
	    ));
  	}
	render() {

		return (<div style={{padding:'5px 10px 0 10px'}}>
			 <div style={{fontSize:'1.1em', fontWeight: 500}}><p>Pēc pašvaldības</p></div>
			 	<InputLabel shrink htmlFor="age-label-placeholder">
	            pašvaldība
	          </InputLabel>
				<Select
					multiple={false}
					value={(this.state.values[0] ? this.state.values[0] : null)}
					onChange={this.handleChange.bind(this)}
					labelStyle={{fontSize: '12px'}}
					style={{width: 180, fontSize: '12px'}}
					autoWidth={true}
				>
		        {this.menuItems(this.state.values, this.state.municipalities)}
		      </Select>
		</div>);
	}
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
  
  }
}

const MenuSection = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Autonomy);

export default MenuSection;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/autonomy/container.js